import constants from 'constants';
const {
  SET_QUIZ_STATUS
} = constants;

export const setQuizStatus = (status, result = 0) => ({
  type: SET_QUIZ_STATUS,
  result,
  status
})



// WEBPACK FOOTER //
// ./src/actions/quiz.js